import { computed, observable, makeObservable } from 'mobx';
import setupAutosave from './autosave';

class ModelAutosaver {
  model;

  constructor(model) {
    makeObservable(this, {
      model: observable,
      status: computed
    });

    this.model = model;
  }

  setup(callback) {
    this.autosaver = setupAutosave(this.model, callback);
  }

   autosave() {
    this.autosaver.autosave();
  }

   autosaveImmediately() {
    this.autosaver.autosaveImmediately();
  }

  clearAutosaver() {
    delete this.model.autosaver;
  }

  async flush() {
    await this.autosaver.autosave.flush();
  }

  get status() {
    return this.autosaver.status;
  }
}

export default function setupAutosaveModel(model, callback) {
  if (model.autosaver) {
    throw new Error('Model already has an autosaver');
  }

  const modelAutosaver = new ModelAutosaver(model);
  modelAutosaver.setup(callback);

  Object.defineProperty(
    model,
    'autosaver',
    {
      configurable: true,
      get: () => modelAutosaver
    }
  );
}
